export const gitCommit = '8325500b'
